import { Paginated } from "@/@types/generics/paginated";
import { GrievanceNotification } from "@/@types/sintegrada/GrievanceNotification";
import { Patient } from "@/@types/sintegrada/Patient";
import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { getSintegradaServerApi } from "@/services/api";
import { ResumeGrouped } from "@/services/esus/attendanceService";

export type GrievanceNotificationItemData = {
	patient: Patient;
	attendanceDate: string;
	notificationItemCreatedAt: string;
	firstSymptomAt?: string;
	riskClassification: RiskClassification;
	notification: GrievanceNotification;
};

type GrievanceNotificationItemParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
	startDate: string;
	endDate: string;
	grievanceNotificationId?: number | null;
	riskClassificationId?: number | null;
	gender?: string;
	youngerAge?: string;
	olderAge?: string;
	search?: string;
	pageNumber: number;
	pageSize?: number;
};

export async function getGrievanceNotificationItems({
	uf,
	ibgeCode,
	cnes,
	...params
}: GrievanceNotificationItemParams) {
	const url = `/GrievanceNotificationItem/grievance-notification-items`;

	const { data } = await getSintegradaServerApi().get<Paginated<GrievanceNotificationItemData>>(
		url,
		{
			ibgeCode,
			cnes,
			...params,
		}
	);

	return data || ({} as Paginated<GrievanceNotificationItemData>);
}

export async function getGroupedByGrievanceNotification({
	uf,
	ibgeCode,
	cnes,
	...params
}: GrievanceNotificationItemParams) {
	const url = `/GrievanceNotificationItem/grouped-by-grievance-notification`;

	const { data } = await getSintegradaServerApi().get<
		ResumeGrouped<GrievanceNotification, object>[]
	>(url, {
		ibgeCode,
		cnes,
		...params,
	});

	return data || [];
}
